

function VinEncoder() 
{
    return (
        <div>
            <h1>VIN Encoder</h1>
            <h2>to be made...</h2>
        </div>
    );
};

export default VinEncoder;